import { faArrowTurnDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from "classnames"
import React, { useEffect } from "react"
import { useAuth } from "../../../hooks/auth"
import { useNana } from "../../../hooks/useNana"

const TutorialComponent = ({
  clickHereFirstRef,
}: {
  clickHereFirstRef: React.MutableRefObject<HTMLDivElement | null>
}) => {
  const { plateView, model, commander } = useNana()
  const { hasMadeAnyChange } = useAuth()

  useEffect(() => {
    if (!plateView) return
    plateView.updateClickHereFirstLocation()
  }, [plateView, clickHereFirstRef.current])

  console.log("hasMadeAnyChange", hasMadeAnyChange)
  if (hasMadeAnyChange) return null
  if (commander.history.length > 0) return null
  if (!plateView) return null

  return (
    <div ref={clickHereFirstRef} className={classNames("pl-3 pt-2 absolute flex")}>
      <FontAwesomeIcon
        icon={faArrowTurnDown}
        className="w-9 h-9  dark:text-gray-200"
        flip="horizontal"
      />
      <div className="text-lg">Click here first22!</div>
    </div>
  )
}

export default TutorialComponent
